import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useSignOut } from "./use-sign-out";

import "./auth-error.css";

// Shown instead of redirecting to Auth0 again when a sign-in comes back with
// an error (e.g. a post-login Action denial). An automatic redirect here would
// loop, and every round is another MFA prompt.
const AuthError = ({ error }) => {
  const { loginWithRedirect } = useAuth0();
  const signOut = useSignOut();
  // A failed callback still carries the page the user was going to.
  const returnTo = error?.appState?.returnTo?.startsWith("/")
    ? error.appState.returnTo
    : "/";

  return (
    <div className="auth-error">
      <h1 className="auth-error__title">We couldn't sign you in</h1>
      {error?.message && <p className="auth-error__message">{error.message}</p>}
      <div className="auth-error__actions">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => loginWithRedirect({ appState: { returnTo } })}
        >
          Try again
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={signOut}
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default AuthError;
